// extracted by mini-css-extract-plugin
export default {"map":"Contacts_map__6+NEr","contacts":"Contacts_contacts__2RDRg","link":"Contacts_link__ZORi8"};